import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const UltraverseTshirtBlackProduct = {
  title: "'Ultraverse' Black T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/verse-tee-black.png/w_1920',
  shopifyProductName: 'Ultraverse T-shirt',
  tag: undefined,
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const UltraverseTshirtBlackShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691329417458',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329417458:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691329482994',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329482994:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691329548530',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329548530:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691329614066',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329614066:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691329679602',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329679602:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200400601184',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400601184:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200400666720',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400666720:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200400732256',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400732256:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200400797792',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400797792:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200400863328',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400863328:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718633435196',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633435196:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718633500732',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633500732:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718633566268',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633566268:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718633631804',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633631804:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718633697340',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633697340:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40320559939654',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40320559939654:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40320559906886',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40320559906886:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40320559841350',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40320559841350:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40320559874118',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40320559874118:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40320559808582',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40320559808582:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202539397438',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539397438:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202539462974',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539462974:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202539528510',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539528510:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202539594046',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539594046:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202539659582',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539659582:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
